module.exports = __webpack_public_path__ + "static/media/s-gofr2.086d89e2.png";